import * as $runtime from "../runtime.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
const $InputType = tag => tag;
const InputButton = /* #__PURE__ */ $InputType("InputButton");
const InputCheckbox = /* #__PURE__ */ $InputType("InputCheckbox");
const InputColor = /* #__PURE__ */ $InputType("InputColor");
const InputDate = /* #__PURE__ */ $InputType("InputDate");
const InputDatetimeLocal = /* #__PURE__ */ $InputType("InputDatetimeLocal");
const InputEmail = /* #__PURE__ */ $InputType("InputEmail");
const InputFile = /* #__PURE__ */ $InputType("InputFile");
const InputHidden = /* #__PURE__ */ $InputType("InputHidden");
const InputImage = /* #__PURE__ */ $InputType("InputImage");
const InputMonth = /* #__PURE__ */ $InputType("InputMonth");
const InputNumber = /* #__PURE__ */ $InputType("InputNumber");
const InputPassword = /* #__PURE__ */ $InputType("InputPassword");
const InputRadio = /* #__PURE__ */ $InputType("InputRadio");
const InputRange = /* #__PURE__ */ $InputType("InputRange");
const InputReset = /* #__PURE__ */ $InputType("InputReset");
const InputSearch = /* #__PURE__ */ $InputType("InputSearch");
const InputSubmit = /* #__PURE__ */ $InputType("InputSubmit");
const InputTel = /* #__PURE__ */ $InputType("InputTel");
const InputText = /* #__PURE__ */ $InputType("InputText");
const InputTime = /* #__PURE__ */ $InputType("InputTime");
const InputUrl = /* #__PURE__ */ $InputType("InputUrl");
const InputWeek = /* #__PURE__ */ $InputType("InputWeek");
const renderInputType = v => {
  if (v === "InputButton") { return "button"; }
  if (v === "InputCheckbox") { return "checkbox"; }
  if (v === "InputColor") { return "color"; }
  if (v === "InputDate") { return "date"; }
  if (v === "InputDatetimeLocal") { return "datetime-local"; }
  if (v === "InputEmail") { return "email"; }
  if (v === "InputFile") { return "file"; }
  if (v === "InputHidden") { return "hidden"; }
  if (v === "InputImage") { return "image"; }
  if (v === "InputMonth") { return "month"; }
  if (v === "InputNumber") { return "number"; }
  if (v === "InputPassword") { return "password"; }
  if (v === "InputRadio") { return "radio"; }
  if (v === "InputRange") { return "range"; }
  if (v === "InputReset") { return "reset"; }
  if (v === "InputSearch") { return "search"; }
  if (v === "InputSubmit") { return "submit"; }
  if (v === "InputTel") { return "tel"; }
  if (v === "InputText") { return "text"; }
  if (v === "InputTime") { return "time"; }
  if (v === "InputUrl") { return "url"; }
  if (v === "InputWeek") { return "week"; }
  $runtime.fail();
};
const eqInputType = {
  eq: x => y => {
    if (x === "InputButton") { return y === "InputButton"; }
    if (x === "InputCheckbox") { return y === "InputCheckbox"; }
    if (x === "InputColor") { return y === "InputColor"; }
    if (x === "InputDate") { return y === "InputDate"; }
    if (x === "InputDatetimeLocal") { return y === "InputDatetimeLocal"; }
    if (x === "InputEmail") { return y === "InputEmail"; }
    if (x === "InputFile") { return y === "InputFile"; }
    if (x === "InputHidden") { return y === "InputHidden"; }
    if (x === "InputImage") { return y === "InputImage"; }
    if (x === "InputMonth") { return y === "InputMonth"; }
    if (x === "InputNumber") { return y === "InputNumber"; }
    if (x === "InputPassword") { return y === "InputPassword"; }
    if (x === "InputRadio") { return y === "InputRadio"; }
    if (x === "InputRange") { return y === "InputRange"; }
    if (x === "InputReset") { return y === "InputReset"; }
    if (x === "InputSearch") { return y === "InputSearch"; }
    if (x === "InputSubmit") { return y === "InputSubmit"; }
    if (x === "InputTel") { return y === "InputTel"; }
    if (x === "InputText") { return y === "InputText"; }
    if (x === "InputTime") { return y === "InputTime"; }
    if (x === "InputUrl") { return y === "InputUrl"; }
    return x === "InputWeek" && y === "InputWeek";
  }
};
const ordInputType = {
  compare: x => y => {
    if (x === "InputButton") {
      if (y === "InputButton") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputButton") { return Data$dOrdering.GT; }
    if (x === "InputCheckbox") {
      if (y === "InputCheckbox") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputCheckbox") { return Data$dOrdering.GT; }
    if (x === "InputColor") {
      if (y === "InputColor") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputColor") { return Data$dOrdering.GT; }
    if (x === "InputDate") {
      if (y === "InputDate") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputDate") { return Data$dOrdering.GT; }
    if (x === "InputDatetimeLocal") {
      if (y === "InputDatetimeLocal") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputDatetimeLocal") { return Data$dOrdering.GT; }
    if (x === "InputEmail") {
      if (y === "InputEmail") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputEmail") { return Data$dOrdering.GT; }
    if (x === "InputFile") {
      if (y === "InputFile") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputFile") { return Data$dOrdering.GT; }
    if (x === "InputHidden") {
      if (y === "InputHidden") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputHidden") { return Data$dOrdering.GT; }
    if (x === "InputImage") {
      if (y === "InputImage") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputImage") { return Data$dOrdering.GT; }
    if (x === "InputMonth") {
      if (y === "InputMonth") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputMonth") { return Data$dOrdering.GT; }
    if (x === "InputNumber") {
      if (y === "InputNumber") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputNumber") { return Data$dOrdering.GT; }
    if (x === "InputPassword") {
      if (y === "InputPassword") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputPassword") { return Data$dOrdering.GT; }
    if (x === "InputRadio") {
      if (y === "InputRadio") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputRadio") { return Data$dOrdering.GT; }
    if (x === "InputRange") {
      if (y === "InputRange") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputRange") { return Data$dOrdering.GT; }
    if (x === "InputReset") {
      if (y === "InputReset") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputReset") { return Data$dOrdering.GT; }
    if (x === "InputSearch") {
      if (y === "InputSearch") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputSearch") { return Data$dOrdering.GT; }
    if (x === "InputSubmit") {
      if (y === "InputSubmit") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputSubmit") { return Data$dOrdering.GT; }
    if (x === "InputTel") {
      if (y === "InputTel") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputTel") { return Data$dOrdering.GT; }
    if (x === "InputText") {
      if (y === "InputText") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputText") { return Data$dOrdering.GT; }
    if (x === "InputTime") {
      if (y === "InputTime") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputTime") { return Data$dOrdering.GT; }
    if (x === "InputUrl") {
      if (y === "InputUrl") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y === "InputUrl") { return Data$dOrdering.GT; }
    if (x === "InputWeek" && y === "InputWeek") { return Data$dOrdering.EQ; }
    $runtime.fail();
  },
  Eq0: () => eqInputType
};
export {
  $InputType,
  InputButton,
  InputCheckbox,
  InputColor,
  InputDate,
  InputDatetimeLocal,
  InputEmail,
  InputFile,
  InputHidden,
  InputImage,
  InputMonth,
  InputNumber,
  InputPassword,
  InputRadio,
  InputRange,
  InputReset,
  InputSearch,
  InputSubmit,
  InputTel,
  InputText,
  InputTime,
  InputUrl,
  InputWeek,
  eqInputType,
  ordInputType,
  renderInputType
};
